import{defineMessages}from'react-intl';

export default defineMessages({
button_back:{
id:'i18n.selection_panel.button_back',
defaultMessage:'Back'},

button_submit:{
id:'i18n.selection_panel.button_submit',
defaultMessage:'Submit'},

label_stock_lift:{
id:'i18n.selection_panel.label_stock_lift',
defaultMessage:'Stock Lift'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9TdG9ja0xpZnRTZWxlY3Rpb25QYWdlL1NlbGVjdGlvblBhbmVsL1NlbGVjdGlvblBhbmVsLm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwiYnV0dG9uX2JhY2siLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwiYnV0dG9uX3N1Ym1pdCIsImxhYmVsX3N0b2NrX2xpZnQiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLFlBQWE7QUFDWEMsR0FBSSxrQ0FETztBQUVYQyxlQUFnQixNQUZMLENBRGU7O0FBSzVCQyxjQUFlO0FBQ2JGLEdBQUksb0NBRFM7QUFFYkMsZUFBZ0IsUUFGSCxDQUxhOztBQVM1QkUsaUJBQWtCO0FBQ2hCSCxHQUFJLHVDQURZO0FBRWhCQyxlQUFnQixZQUZBLENBVFUsQ0FBZixDQUFmIiwiZmlsZSI6IlNlbGVjdGlvblBhbmVsLm1lc3NhZ2VzLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBkZWZpbmVNZXNzYWdlcyB9IGZyb20gJ3JlYWN0LWludGwnO1xuXG5leHBvcnQgZGVmYXVsdCBkZWZpbmVNZXNzYWdlcyh7XG4gIGJ1dHRvbl9iYWNrOiB7XG4gICAgaWQ6ICdpMThuLnNlbGVjdGlvbl9wYW5lbC5idXR0b25fYmFjaycsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdCYWNrJyxcbiAgfSxcbiAgYnV0dG9uX3N1Ym1pdDoge1xuICAgIGlkOiAnaTE4bi5zZWxlY3Rpb25fcGFuZWwuYnV0dG9uX3N1Ym1pdCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdTdWJtaXQnLFxuICB9LFxuICBsYWJlbF9zdG9ja19saWZ0OiB7XG4gICAgaWQ6ICdpMThuLnNlbGVjdGlvbl9wYW5lbC5sYWJlbF9zdG9ja19saWZ0JyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1N0b2NrIExpZnQnLFxuICB9LFxufSk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/pages/StockLiftSelectionPage/SelectionPanel/SelectionPanel.messages.js
// module id = 2334
// module chunks = 0